const ROUTES = {
    // --- MAIN PAGES ---
    HOME:     '/',
    SERVICES: '/services',
    WORK:     '/work',
    ROBOTICS: '/robotics',
    // ADOPT:    '/adopt-africa',
    ABOUT:    '/about',
    CONTACT:  '/contact',

    // --- FOOTER PAGES ---
    PRIVACY:  '/privacy-policy',
    TERMS:    '/terms-of-service',
    COOKIES:  '/cookie-policy',

    // --- UTILITY ---
    NOT_FOUND: '*',
};

export default ROUTES;